export const NAMESPACE = 'clientDevice';
